import { TabsList } from './TabsList'
import { TabLink } from './TabLink'
import styles from './Tabs.module.css'

export interface TabNavigationItem {
  /** Identificador único da aba */
  value: string
  /** Label de exibição */
  label: string
  /** Rota para navegação */
  to: string
  /** Ícone opcional (Iconify) */
  icon?: string
  /** Badge opcional */
  badge?: string | number
  /** Se está desabilitada */
  disabled?: boolean
  active?: boolean
}

export interface TabsNavigationProps {
  /** Lista de abas para navegação */
  tabs: TabNavigationItem[]
  /** Classe CSS adicional */
  className?: string
  /** Label para acessibilidade */
  'aria-label'?: string
}

/**
 * Componente de navegação de abas usando rotas.
 * Renderiza uma lista de abas que navegam entre páginas diferentes.
 */
export function TabsNavigation({
  tabs,
  className,
  'aria-label': ariaLabel,
}: TabsNavigationProps) {
  return (
    <div className={[styles.tabs, className].filter(Boolean).join(' ')}>
      <TabsList aria-label={ariaLabel || 'Abas de navegação'}>
        {tabs.map((tab, index) => (
          <TabLink
            key={tab.value}
            value={tab.value}
            to={tab.to}
            icon={tab.icon}
            badge={tab.badge}
            disabled={tab.disabled}
            active={tab.active}
            isBaseRoute={index === 0}
          >
            {tab.label}
          </TabLink>
        ))}
      </TabsList>
    </div>
  )
}
